import axios from "axios";
import { SignoutTrigger, toggleSnacker } from "../domian/app/AppSlice";
import { store } from "../store/store";
import { errorOpen } from "./Api.service";
const envCollection = [
  "demandforecast.prodns",
  "demandforecast.prod",
  "demand-ns-frontend",
];
const url = window.location.href;

export let appEnvUrl = envCollection.filter((e: any) => {
  return url.includes(e.toLowerCase());
});

export let finalUrl = "";

switch (appEnvUrl[0]) {
  case "demandforecast.prodns":
    finalUrl = process.env.REACT_APP_API_BASE_URL_PROD_NS as string;
    break;
  case "demandforecast.prod":
    finalUrl = process.env.REACT_APP_API_BASE_URL_PROD as string;
    break;
  case "demand-ns-frontend":
    finalUrl = process.env.REACT_APP_API_BASE_URL_DEV as string;
    break;
  default:
    finalUrl = process.env.REACT_APP_API_BASE_URL_DEV as string;
    break;
}

const API = axios.create({
  baseURL: finalUrl,
});
API.interceptors.request.use((config) => {
  let token = store.getState().globalAppState.authToken;
  if (config.headers) {
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});
API.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    const errCode = [401];
    if (errCode.includes(err.response.status)) {
      //localStorage authToken should clear
      // store.dispatch(logOut)
      store.dispatch(SignoutTrigger());
      store.dispatch({ type: "SIGNOUT_REQUEST" });
      store.dispatch(
        toggleSnacker(errorOpen("The Session Is Expired Please Login Again"))
      );
      // navigate("/");
      // eslint-disable-next-line no-restricted-globals
      // location.href = "/";
      // return false;
    }
    throw err;
  }
);
export default API;
